export const THREE_MINUTES = '3 minutes from finish'
export const TWO_TO_THREE_MINUTES = '2 - 3 minutes from finish'
export const TWO_MINUTES = '2 minutes from finish'
export const ONE_TO_TWO_MINUTES = '1 - 2 minutes from finish'
export const ONE_MINUTE = '1 minute from finish'
export const LESS_THAN_ONE_MINUTE = 'Less than 1 minute from finish'
export const FINISHED = 'Finished!'
